<div class="container">
  <div class="row">
    <div *ngIf="env.env_name !== 'PROD'" class="ribbon"><a href="">UAT</a></div>
    <app2-header></app2-header>
    <router-outlet></router-outlet>
  </div>
  <app2-footer class="isHideInMobile"></app2-footer>
</div>
